import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'opac-amautas-subscription-dialog',
  templateUrl: './amautas-subscription-dialog.component.html',
  styleUrls: ['./amautas-subscription-dialog.component.scss']
})
export class AmautasSubscriptionDialogComponent {
  /**
   * Determines if the dialog is open
   */
  @Input() open = false;
  /**
   * Emits when the accept button is clicked
   */
  @Output() accept = new EventEmitter<void>();
  /**
   * Emits when the cancel or close button is clicked
   */
  @Output() cancel = new EventEmitter<void>();
}
